import React from "react";
import customer from "../../../Assets/footer-customer-icon.svg";
import madeInInida from "../../../Assets/footer-made-in-india-icon.svg";
import assuredQuality from "../../../Assets/footer-quality-icon.svg";
import securePayment from "../../../Assets/footer-secure-payment-icon.svg";
import useSiteSettings from "../../../hooks/useSiteSettings";

const claims = [
  { icon: madeInInida, title: "Made in India", sub: "Crafted across Rajasthan" },
  { icon: assuredQuality, title: "Assured Quality", sub: "Handpicked premium fabrics" },
  { icon: securePayment, title: "Secure Payments", sub: "Safe & encrypted checkout" },
  { icon: customer, title: "Empowering Weavers", sub: "Supporting local artisans" },
];

const MarketingClaims = () => {
  const brand = useSiteSettings().brandName || "";
  return (
    <section className="border-t border-[#eadcc0] bg-[#fffbf2] py-14">
      <div className="mb-10 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#b28585]">
          {brand ? `The ${brand} Promise` : "Our Promise"}
        </p>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-x-6 gap-y-10 px-6 md:grid-cols-4">
        {claims.map((c) => (
          <div key={c.title} className="group flex flex-col items-center text-center">
            <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-[#f8ecd7] to-[#efdcbd] shadow-sm ring-1 ring-[#e0b65c]/40 transition-transform duration-300 group-hover:-translate-y-1">
              <img src={c.icon} alt={c.title} className="h-9 w-9" />
            </div>
            <p className="text-sm font-semibold uppercase tracking-wide text-[#511d00]">
              {c.title}
            </p>
            <p className="mt-1 text-xs text-[#8a7575]">{c.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MarketingClaims;
